module.exports = __webpack_public_path__ + "img/cken2.19219ceb.jpeg";